import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { SideBar } from "./inc/sideBar";
import { TopHeader } from "./inc/topHeader";
import { UpdateStudent } from "./updateStudent";
import { StudentStudy } from "./studentStudy";
import { OveralProgress } from "./overalProgress";

const StudentDetails = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeMenu, setActiveMenu] = useState(null);
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1024
  );

  const [activeTab, setActiveTab] = useState("info");

  const tabs = [
    { id: "info", label: "Student Information", icon: "fa-graduation-cap" },
    { id: "study", label: "Student Study", icon: "fa-book" },
    // { id: "progress", label: "Progress", icon: "fa-chart-line" },
  ];

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (windowWidth < 768) {
      setSidebarOpen(false);
    }
  }, [windowWidth]);

  const toggleMenu = (menu) => {
    setActiveMenu(activeMenu === menu ? null : menu);
  };

  return (
    // <div className="wrapper">
    <div className="d-flex position-relative" style={{ minHeight: "100vh" }}>
      <SideBar
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        activeMenu={activeMenu}
        toggleMenu={toggleMenu}
        windowWidth={windowWidth}
      />
      <div className="main-panel">
        <TopHeader
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          windowWidth={windowWidth}
        />

        <div className="container mt-0">
          <div className="page-inner">
            <div className="page-header bg-white zis-shadow rounded-2 mt-2 ">
              <ul className="breadcrumbs my-md-3 mb-3 ms-0">
                <li className="nav-home">
                <Link to="/coordinator" className="ps-3 ps-md-0">
                    <span className="fa fa-home"></span>
                    </Link>
                </li>
                <li className="separator">
                   <i className="fas fa-chevron-right text-secondary"></i>
                </li>
                <li className="nav-item text-black fw-semibold">
                  <Link to="/coordinator/student">Manage students</Link>
                </li>
                <li className="separator">
                   <i className="fas fa-chevron-right text-secondary"></i>
                </li>
                <li className="nav-item text-black fw-semibold">
                  <Link to="#">Student informations</Link>
                </li>
              </ul>
            </div>

            <OveralProgress />

            <div className="card rounded-0 zis-shadow ">
              <ul className="nav nav-tabs">
                {tabs.map((tab) => (
                  <li
                    key={tab.id}
                    className={`nav-item ${
                      activeTab === tab.id ? "active" : ""
                    }`}
                    onClick={() => setActiveTab(tab.id)}
                    style={{
                      cursor: "pointer",
                      borderTop:
                        activeTab === tab.id
                          ? "3px solid #3c8dbc"
                          : "3px solid transparent",
                      padding: "14px 15px",
                      display: "flex",

                      alignItems: "center",
                      color: activeTab === tab.id ? "#6c757d" : "#000",
                      fontWeight: activeTab === tab.id ? "600" : "500",
                    }}
                  >
                    <i
                      className={`fa ${tab.icon}`}
                      style={{
                        marginRight: "8px",
                        color: activeTab === tab.id ? "#3c8dbc" : "#6c757d",
                      }}
                    />
                    {tab.label}
                  </li>
                ))}
              </ul>

              {/* Tab Content */}
              <div className="tab-content">
                {activeTab === "info" && (
                  <div className="tab-pane active">
                    <UpdateStudent />
                  </div>
                )}

                {activeTab === "study" && (
                  <div className="tab-pane active">
                    <StudentStudy />
                  </div>
                )}

                {/* {activeTab === "progress" && (
                  <div className="tab-pane active">
                    <StudentProgress />
                  </div>
                )} */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentDetails;
